export const created = (state) => state.created;
export const error = (state) => state.error;
export const isLoading = (state) => state.isLoading;
export const violations = (state) => state.violations;
export const retrieved = (state) => state.retrieved;
